import React, { FC } from "react";

import { IFavouritesSettingsBulkExportProps } from "./FavouritesSettingsBulkExport.types";
import { BulkExportStepper } from "../../../../bulkexport/components/BulkExportStepper";
import { FavouritesSettingsHeader } from "../FavouritesSettingsHeader";
import { useStyles } from "../FavouritesSettings.styles";
import { FavouritesSettingsActions } from "../FavouritesSettingsActions";
import { useFavouriteProviderContext } from "../../../../bulkexport/providers/FavouriteProvider/FavouriteProvider.context";
import { BulkExportType } from "../../../../bulkexport/components/BulkExportStepper/BulkExportStepper.types";

export const FavouritesSettingsBulkExport: FC<IFavouritesSettingsBulkExportProps> = ({ item }) => {
  const classes = useStyles();

  const context = useFavouriteProviderContext();
  const state = context?.state;
  const actions = context.actions;
  const isFavouriteChanged = state?.isFavouriteChanged;
  const savedFavouriteItem = state?.savedFavouriteItem;
  const deleteFavourite = actions?.deleteFavourite;
  const updateFavourite = actions?.updateFavourite;
  const cancelFavouriteChanges = actions?.cancelFavouriteChanges;

  return (
    <div className={classes.root}>
      <FavouritesSettingsHeader item={item} />
      <BulkExportStepper item={item} bulkType={BulkExportType.Favourite} />
      <FavouritesSettingsActions
        onDelete={deleteFavourite}
        onSave={updateFavourite}
        onCancel={cancelFavouriteChanges}
        isChanged={isFavouriteChanged}
        savedFavouriteItem={savedFavouriteItem}
      />
    </div>
  );
};
